import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube } from "lucide-react";

export default function Footer() {
    return (
        <footer
            className="bg-ink text-parchment border-t-2 border-ink mt-24"
            data-testid="main-footer"
        >
            <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
                <div className="col-span-2">
                    <div className="font-display text-5xl tracking-tight">
                        DESASHOP
                    </div>
                    <p className="font-hand text-2xl text-gold mt-2">
                        il bottino dei pirati
                    </p>
                    <p className="mt-6 text-sm text-parchment/70 max-w-sm leading-relaxed">
                        Action figures ufficiali e da collezione del mondo di
                        One Piece. Spedizioni rapide in tutta Italia, dal
                        Mare Orientale al Nuovo Mondo.
                    </p>
                </div>
                <div>
                    <div className="font-display text-xl tracking-wider mb-4 text-bounty">
                        NAVIGA
                    </div>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <Link to="/figure">Tutte le figure</Link>
                        </li>
                        <li>
                            <Link to="/figure?crew=Ciurma+di+Cappello+di+Paglia">
                                Mugiwara
                            </Link>
                        </li>
                        <li>
                            <Link to="/figure?crew=4+Imperatori">
                                Yonko
                            </Link>
                        </li>
                        <li>
                            <Link to="/figure?crew=Marina">Marina</Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <div className="font-display text-xl tracking-wider mb-4 text-bounty">
                        EQUIPAGGIO
                    </div>
                    <ul className="space-y-2 text-sm">
                        <li>desashop.net</li>
                        <li>
                            <Link to="/admin" data-testid="footer-admin-link">
                                Pannello capitano
                            </Link>
                        </li>
                        <li>Spedizioni & resi</li>
                        <li>Contatti</li>
                    </ul>
                    <div className="flex gap-3 mt-5">
                        <a
                            href="#"
                            className="w-9 h-9 border-2 border-parchment flex items-center justify-center hover:bg-bounty"
                        >
                            <Instagram size={16} />
                        </a>
                        <a
                            href="#"
                            className="w-9 h-9 border-2 border-parchment flex items-center justify-center hover:bg-bounty"
                        >
                            <Twitter size={16} />
                        </a>
                        <a
                            href="#"
                            className="w-9 h-9 border-2 border-parchment flex items-center justify-center hover:bg-bounty"
                        >
                            <Youtube size={16} />
                        </a>
                    </div>
                </div>
            </div>
            <div className="border-t border-parchment/20 py-5 text-center text-xs font-mono text-parchment/60">
                © {new Date().getFullYear()} Desashop · Il mondo di One Piece ©
                Eiichiro Oda / Shueisha · Fan store non ufficiale
            </div>
        </footer>
    );
}
